import * as Yup from 'yup';

export const initialValues = {
  shopName: '',
  shopType: '',
  ownerName: '',
  mob: '',
  establishmentDate: '',  
  emailid: '',
  website: '',
  address: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'India',
  user_otp: '',
  upaswd:'',
  user_status:'0',
  user_role:'user',
  businessCertificate: null,
  gstCertificate: null,
  adharCard: null,
  utilityBill: null,  
};

// Step 1: Basic Info
export const validationStep1 = Yup.object({
  shopName: Yup.string().required('Shop Name is required').min(3, 'Shop Name must be at least 3 characters long'),
  shopType: Yup.string().required('Shop Type is required'),
  ownerName: Yup.string().required('Owner Name is required'),
  mob: Yup.string().length(10, 'Mobile number must be 10 digits').required('Mobile Number is required'),  
});

// Step 2: Address & Contact
export const validationStep2 = Yup.object({  
  emailid: Yup.string().email('Invalid email').required('Email is required'),  
  address: Yup.string().required('Address is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  postalCode: Yup.string().length(6, 'Postal Code must be exactly 6 digits').required('Postal Code is required'),
  country: Yup.string().required('Country is required'),
});

// Step 3: OTP & Documents
export const validationStep3 = Yup.object().shape({
  user_otp: Yup.string().length(4, 'OTP must be 4 digits').required('OTP is required'),   
});
